<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <stage-comment-item></stage-comment-item>

    <div v-if="showUI" class="margin-top-20">
      <div class="item-heading-desc-div margin-left-10 margin-right-10">
        <weex-text
          class="item-heading"
          v-html="chooseEMISchemeHeading"
        ></weex-text>
      </div>

      <wxc-radio
        class="margin-left-20 margin-right-20"
        :list="emiSchemesOption"
        :config="radioButtonConfig"
        @wxcRadioListChecked="onEMISchemeSelected($event.value)"
      ></wxc-radio>

      <wxc-button
        text="Next"
        class="horizontal-center margin-top-20"
        type="blue"
        @wxcButtonClicked="onSubmitClicked"
      ></wxc-button>
    </div>
  </div>
</template>
<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import RefreshItem from "../layout/RefreshItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import StageCommentItem from "../layout/StageCommentItem";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import WxcRadio from "../../../weex-ui/packages/wxc-radio/index";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import AlertService from "../core/alert/AlertService";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import { EntityType } from "../../utils/EntityType";
import { Activities } from "../../utils/ActivityNavigator";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import AttributeUtil, { AttributeDetails } from "../../utils/AttributeUtil";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import { LoanStageConfigKeys } from "../../utils/LoanStageConfigKeys";

const SELECT_EMI_OPTION = "Please select an EMI Scheme option";

export default {
  name: "EMISchemeOptionActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    WxcButton,
    WxcRadio,
    Loading,
    StageCommentItem,
    RefreshItem,
    ErrorAlertItem
  },
  data: () => ({
    title: "Choose EMI Scheme",
    showRefreshItem: false,
    showUI: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    chooseEMISchemeHeading: "",
    emiSchemesOption: [],
    selectedEMIOption: ""
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    onEMISchemeSelected(selectedEMIOption) {
      this.selectedEMIOption = selectedEMIOption;
    },

    onSubmitClicked() {
      if (this.checkForValidation()) {
        this.loading = true;
        DataSource.createOrUpdateAttribute(
          AttributeUtil.getAttributeUpdateDto(
            EntityType.LOANS,
            LoanScopeDataHolder.getLoanId(),
            AttributeUtil.getSingleAttributeData(
              AttributeDetails.EMI_SCHEME_OPTION.key,
              AttributeDetails.EMI_SCHEME_OPTION.name,
              this.selectedEMIOption
            )
          )
        )
          .then(res => {
            this.loading = false;
            if (res.errorOccurred) {
              this.showError(res.data);
            } else {
              this.completeCurrentTaskAndGetNextTask();
            }
          })
      }
    },

    checkForValidation() {
      if (!this.selectedEMIOption) {
        this.showToast(SELECT_EMI_OPTION);
        return false;
      }

      return true;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(
        LoanScopeDataHolder.getLoanId(),
        this.currentTaskName
      )
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            this.emiSchemesOption = [];
            const properties = stageConfigDataRes.data
              ? stageConfigDataRes.data[LoanStageConfigKeys.PROPERTIES]
              : {};
            if (properties) {
              this.chooseEMISchemeHeading = properties[LoanStageConfigKeys.HEADING];
              const schemes = properties[LoanStageConfigKeys.OPTIONS];
              if (schemes) {
                for (let [schemeTitle, schemeValue] of Object.entries(schemes)) {
                  this.emiSchemesOption.push({ title: schemeTitle, value: schemeValue });
                }
              }
            }
          }
        })
    }
  },

  created: function () {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.EMI_SCHEME_OPTION];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON;
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>

